import { ProjectIssuanceConstants } from "../../../../../../constants";
import { PreAccessInventoryTab } from "../components";
import Inventory from "../Inventory";
import { useInventoryTabWithPreAccess } from "./useInventoryTabWithPreAccess";

const InventoryTabWithPreAccess = (): JSX.Element => {
  const { projectDetails, publicProjectDetails } = useInventoryTabWithPreAccess();

  if (projectDetails) {
    return <Inventory />;
  }

  return (
    <PreAccessInventoryTab
      projectUuid={publicProjectDetails?.uuid}
      unitMeasurement={
        publicProjectDetails?.unitMeasurements?.[0] ?? ProjectIssuanceConstants.ISSUANCE_UNIT_MEASUREMENT_CARBON
      }
    />
  );
};

export default InventoryTabWithPreAccess;
